/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { Component } from '@wordpress/element';
import memoize from 'memize';
import times from 'lodash/times';

import {
	RichText,
	InnerBlocks,
	withColors,
} from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';
import { generateCustomStyleCode } from '../../extensions/custom-styles';
import { isEmpty, has } from 'lodash';
import BaseWrapper from '../../components/base-wrapper';

/**
 * Constants
 */
const ALLOWED_BLOCKS = [ 'gutenify/team-member' ];

/**
 * Returns the layouts configuration for a given number of feature items.
 *
 * @param {number} count Number of feature items.
 *
 * @return {Object[]} Columns layout configuration.
 */
const getCount = memoize( ( count ) => {
	return times( count, () => [ 'gutenify/team-member', {
		className: 'has-shadow-dark',
	} ] );
} );

class edit extends Component {
	constructor( props ) {
		super( props );
		this.updateTeams = this.updateTeams.bind( this );
		this.updateState = this.updateState.bind( this );
		this.state = {
			isTitleEditing: false,
		};
	}

	componentDidMount() {
		const { attributes, setAttributes, clientId } = this.props;
		const { blockAdvanceOptions, isSaved } = attributes;

		let saveIt = false;
		if ( ! isSaved ) {
			setAttributes( { isSaved: true, blockClientId: clientId } );
			saveIt = true;
		}
		generateCustomStyleCode( blockAdvanceOptions, { ...this.props }, saveIt );
	}

	updateTeams( data ) {
		const { setAttributes } = this.props;
		setAttributes( {
			...data,
		} );
	}

	updateState( data ) {
		this.setState( {
			...data,
		} );
	}

	render() {
		const { attributes, isSelected, clientId, className, align } = this.props;
		const { title, layout, columnSize, blockAdvanceOptions } = attributes;
		const wrapperClasses = classnames(
			className,
			`align${ align }`,
			`gutenify-admin-team-block-wrapper gutenify-team-${ layout }`,
			`gutenify-team-col-${ columnSize }`
		);

		const titleStyle = {
			color: 'inherit',
		};
		if ( has( blockAdvanceOptions, 'textColor' ) && ! isEmpty( blockAdvanceOptions.textColor ) ) {
			titleStyle.color = blockAdvanceOptions.textColor;
		}

		return (
			<div className={ wrapperClasses }>

				{ isSelected && <Inspector { ...this.props } /> }
				<BaseWrapper { ...this.props }>
					<RichText
						tagName="h2"
						value={ title }
						onChange={ ( content ) => {
							this.updateTeams( { title: content } );
						} }
						placeholder={ __( 'Our Team' ) }
						className="gutenify-admin-team-block-title"
						style={ titleStyle }
					/>
					<div className="gutenify-admin-team-block">
						<InnerBlocks
							allowedBlocks={ ALLOWED_BLOCKS }
							template={ getCount( 2 ) }
							templateInsertUpdatesSelection={ false }
							orientation={ 'horizontal' }
							__experimentalCaptureToolbars={ true }
							renderAppender={ () => (
								<InnerBlocks.ButtonBlockAppender />
							) }
						/>
					</div>
				</BaseWrapper>

			</div>
		);
	}
}

export default withColors( 'backgroundColor', { textColor: 'color' } )( edit );
